import React from 'react';
import {Link} from 'react-router-dom';
import {Store, ChevronLeft, Info} from 'lucide-react';
import {supplierSearch} from '../../pages/supplierDirectoryModel';

export default function SupplierDirectoryTable({rows,search,onOpen}) {
    return <>
        <table className="supplier-directory-table">
            <caption className="supplier-sr-only">قائمة الموردين؛ المؤشرات المالية غير متاحة حتى ربط قارئ الذمم</caption>
            <thead><tr><th scope="col">المورد</th><th scope="col">إجمالي الفواتير</th><th scope="col">المتبقي</th><th scope="col">بيانات الحساب</th><th scope="col"><span className="supplier-sr-only">فتح ملف المورد</span></th></tr></thead>
            <tbody>{rows.map(supplier=><tr key={supplier.id} data-testid={`supplier-card-${supplier.id}`}>
                <td className="supplier-directory-identity"><span className="supplier-avatar"><Store size={22}/></span><div>
                    <Link className="supplier-name-link" to={{pathname:'/suppliers',search:supplierSearch(search,supplier.id)}} onClick={onOpen} data-testid={`supplier-name-${supplier.id}`}><bdi>{supplier.name}</bdi></Link>
                    <span className="supplier-directory-meta">{supplier.category||'غير مصنف'}{supplier.city&&` · ${supplier.city}`}</span>
                </div></td>
                <td data-label="إجمالي الفواتير">غير متاح</td><td data-label="المتبقي">غير متاح</td>
                <td className="supplier-directory-status"><span>قارئ الذمم غير مربوط</span></td>
                <td className="supplier-directory-open"><Link className="supplier-button" to={{pathname:'/suppliers',search:supplierSearch(search,supplier.id)}} onClick={onOpen} aria-label={`فتح ملف ${supplier.name}`}>فتح الملف <ChevronLeft size={16}/></Link></td>
            </tr>)}</tbody>
        </table>
        <footer className="supplier-list-footer"><Info size={17}/><span>تُفتح المشتريات والمستندات بمعرّف المورد نفسه. سداد العميل لا يعني سداد المورد.</span></footer>
    </>;
}
